import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import CountryCode from "../../countryCode";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import { addCustomerStyle } from "./styles";
function Transition(props) {
  return <Slide direction="down" {...props} />;
}
const typeArray = ["VND", "USD"];
class DialogAddCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialogs: this.props.flagOpen || false,
      customer: {
        countryCode: "+84",
        customerMobile: "VND",
        customerName: "",
      },
      content: "",
    };
    this.handleDialogOpen = this.handleDialogOpen.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  handleDialogClose() {
    console.log("handleDialogClose");
    this.setState({
      openDialogs: false,
      customer: {
        countryCode: "+84",
        customerMobile: "VND",
        customerName: "",
      },
    });
  }
  handleDialogOpen() {
    this.setState({ openDialogs: true });
  }
  handleChange = (e) => {
    let target = e.target;
    let { customer } = this.state;
    customer[target.name] = target.value;
    this.setState(customer);
  };
  handleCountryCode = (name, value) => {
    var customer = this.state.customer;
    customer[name] = value;
    this.setState({ customer });
  };
  openDialogConfirm = () => {
    let { t } = this.props;
    let { customer } = this.state;
    let validPhone = _parsePhoneNumber(
      customer.countryCode,
      customer.customerMobile
    ).isValid;
    if (
      !customer.countryCode ||
      !customer.customerMobile ||
      !customer.customerName
    ) {
      this.mSnackbar.handleClick(
        t("customer_addcustomer_please_fill_in_this_form", "warning")
      );
    } else if (!validPhone) {
      this.mSnackbar.handleClick(
        t("customer_addcustomer_phone_number_is_not_valid"),
        "warning"
      );
    } else {
      this.props.addCustomer(this.state.customer);
    }
  };
  render() {
    const { classes, t } = this.props;
    const { countryCode, customerName, customerMobile } = this.state.customer;
    let { customer } = this.state;
    return (
      <Dialog
        open={this.state.openDialogs}
        TransitionComponent={Transition}
        keepMounted
        onClose={this.props.handleDialogClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        classes={{
          paperWidthSm: classes.paperWidthSm,
        }}
      >
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Loading onRef={(id) => (this.loading = id)} />
        <DialogTitle>
          <Typography
            variant="h3"
            gutterBottom
            className={classes.titlePayment}
          >
            {t("membercard_user_member_card_add_customer")}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.DialogContent}>
          <Grid container spacing={16}>
            <Grid item xs={12} sm={12}>
              <CountryCode
                code={countryCode}
                handleCountryCode={this.handleCountryCode}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                useValue={true}
                required={true}
                label={t("membercard_user_member_card_customer_name")}
                className={classes.TextField}
                name="customerName"
                margin="normal"
                fullWidth
                value={customerName}
                onChange={this.handleChange}
                variant="outlined"
                inputProps={{
                  maxLength: 100,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                useValue={true}
                required={true}
                label={t("membercard_user_member_card_customer_mobile")}
                type="number"
                className={classes.TextField}
                name="customerMobile"
                margin="normal"
                fullWidth
                value={customerMobile}
                onChange={this.handleChange}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions classes={{ root: classes.DialogActions }}>
          <Button
            variant="contained"
            color="default"
            className={classes.button}
            onClick={() => this.handleDialogClose()}
          >
            {t("membercard_user_member_card_close")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => this.openDialogConfirm()}
          >
            {t("membercard_user_member_card_add_customer_button")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// Dialog.propTypes = {
//     classes: PropTypes.object.isRequired,
//     theme: PropTypes.object.isRequired,
// };
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(addCustomerStyle, { withTheme: false })(DialogAddCustomer)
  )
);
